var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-expansion-panels',{attrs:{"focusable":""}},[_c('v-expansion-panel',[_c('v-expansion-panel-header',[_c('px-cotacao-detalhes-card-header',{attrs:{"cotacao":_vm.cotacao}})],1),_c('v-expansion-panel-content',[_c('px-cotacao-detalhes-card-details',{attrs:{"cotacao":_vm.cotacao}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }